// extracted by mini-css-extract-plugin
export default {"loadingContainer":"G8d5951","loadingImage":"G435d94"};